import React from "react";
import { Redirect } from "react-router-dom";
import BaseComponent from "./BaseComponent";

class ProtectedRoute extends BaseComponent {
  render() {
    const isAuthenticated = this.identityApi.isUserLoginExpired();
    const Component = this.props.component;
    const path =
      this.props.location.pathname +
      (this.props.location.search ? this.props.location.search : "");
    return isAuthenticated ? (
      <Component {...this.props} />
    ) : (
      <Redirect
        to={{
          pathname: "/login",
          state: { requestedPath: path },
        }}
      />
    );
  }
}

export default ProtectedRoute;
